import { render, staticRenderFns } from "./NavigationForm.vue?vue&type=template&id=272f1f4c&scoped=true&"
import script from "./NavigationForm.vue?vue&type=script&lang=js&"
export * from "./NavigationForm.vue?vue&type=script&lang=js&"
import style0 from "./NavigationForm.vue?vue&type=style&index=0&id=272f1f4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272f1f4c",
  null
  
)

export default component.exports